import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {GetSelectDataParams} from "../types/dynamic.types";
import {Observable} from "rxjs";
import {SelectData} from "../../../../../types/records-table.types";
import {baseUrl} from "../../../../../constants/base-url";
import {jsonPathHeaders} from "../../../../../models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class DynamicApiService {
  private http: HttpClient = inject(HttpClient);

  public getSelectData(getSelectDataParams: GetSelectDataParams): Observable<Array<SelectData>> {
    const { propertyLazySelect, isProduct, productIds, articles } = getSelectDataParams;
    const body = {
      'resourceName': propertyLazySelect.recourseName,
      'providerType': propertyLazySelect.providerType,
      'product': isProduct,
      'productIds': productIds,
      'articles': articles
    };

    return this.http.post<Array<SelectData>>(`${baseUrl}/select-data/search`, body, {
      headers: jsonPathHeaders,
    });
  }
}
